import styled, { css } from "styled-components";
import { DEFAULT_SQUARE_WIDTH, DEFAULT_SQUARE_HEIGHT } from ".";

const squarePositions = {
  1: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(600px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    left: ${`calc(71.68px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  2: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(705px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    right: ${`calc(141px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  3: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    bottom: ${`calc(232px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    right: ${`calc(181px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  4: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(344px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    right: ${`calc(181px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  5: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(476px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    left: ${`calc(796px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  6: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(286px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    left: ${`calc(160px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  7: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(495px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    right: ${`calc(114px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  8: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(642px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    right: ${`calc(147px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  9: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(509px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    right: ${`calc(88px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
  10: ({ size = DEFAULT_SQUARE_WIDTH }) => css`
    top: ${`calc(509px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
    right: ${`calc(147px / (${DEFAULT_SQUARE_WIDTH} / ${size}))`};
  `,
};

export const SquareContainer = styled.div`
  position: relative;
  overflow: hidden;
  width: ${({ size }) => `calc(1080px / ${DEFAULT_SQUARE_WIDTH / size})`};
  aspect-ratio: 1080 / 1350;

  ${({ size, label, shape }) => {
    return (
      (size === 330 || size === 365 || size === 292) &&
      css`
        background-color: #f2f2f5;
        &::after {
          content: ${`"${label}"`};
          position: absolute;
          font-family: "Poppins";
          font-weight: 800;
          font-size: 12.65px;
          color: #3a3a3c;

          ${squarePositions[shape]({ size })}
        }
      `
    );
  }}
`;

export const SquareMask = styled.svg`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 20;
`;

export const SquareImage = styled.img`
  position: absolute;
  object-fit: cover;
  z-index: 10;
  user-select: none;
  ${({ top, left, size, x_axis }) => {
    return css`
      width: ${`${size.width}px`};
      height: ${`${size.height}px`};
      top: ${`${top}px`};
      left: ${`${left}px`};
      object-position: ${`${x_axis}% 50%`};
    `;
  }};
`;

export const DraggableSquareContainer = styled.div`
  position: relative;
  overflow: hidden;
  ${({ size, background = "#fff" }) => {
    return css`
      width: ${`${size}px`};
      height: ${`${size * 1.25}px`};
      background-color: ${background};
    `;
  }};
`;
